/** @jsx h */
import { h } from 'preact'
import AddCalendar from './add-calendar-icon'
import Add from './add-icon'
import Arrow from './arrow-icon'
import ArrowNext from './arrow-next-icon'
import ArrowPrev from './arrow-prev-icon'
import Calendar from './calendar-icon'
import Download from './download-icon'
import Info from './info-icon'
import Localisation from './localisation-icon'
import Phone from './phone-icon'
import Print from './print-icon'
import Search from './search-icon'
import Share from './share-icon'
import Time from './time-icon'
import Validation from './validation-icon'
import Filter from './filter-icon'
import Close from './close-icon'
import Help from './help-icon'
import Store from './store-icon'
import VideoCamera from './video-camera-icon'

const Icon = props => {
  switch (props.name) {
    case 'add-calendar':
      return <AddCalendar {...props} />
    case 'filter':
      return <Filter {...props} />
    case 'close':
      return <Close {...props} />
    case 'arrow-next':
      return <ArrowNext {...props} />
    case 'arrow-prev':
      return <ArrowPrev {...props} />
    case 'add':
      return <Add {...props} />
    case 'arrow':
      return <Arrow {...props} />
    case 'calendar':
      return <Calendar {...props} />
    case 'download':
      return <Download {...props} />
    case 'info':
      return <Info {...props} />
    case 'localisation':
      return <Localisation {...props} />
    case 'phone':
      return <Phone {...props} />
    case 'print':
      return <Print {...props} />
    case 'search':
      return <Search {...props} />
    case 'share':
      return <Share {...props} />
    case 'store':
      return <Store {...props} />
    case 'time':
      return <Time {...props} />
    case 'validation':
      return <Validation {...props} />
    case 'videocamera':
      return <VideoCamera {...props} />
    case 'help':
      return <Help {...props} />
    default:
  }
}

export default Icon
